import { v4 as uuidv4 } from 'uuid';
import { TaskDataRefreshStrategy, TaskScope } from '@shared/enums';

export function LongRunningAction(actionName: string, callback: any = null, taskScope: TaskScope = TaskScope.TASK, refreshStrategy: TaskDataRefreshStrategy = TaskDataRefreshStrategy.CLEANUP) {
  return function <T extends { new(...args: any[]): {} }>(target: T) {
    return class extends target {
      taskId = uuidv4();
      actionName = actionName;
      callback = callback;
      taskScope = taskScope;
      refreshStrategy = refreshStrategy;

      log(msg: string) { console.log(`${actionName} Extended ${msg}`); }
    };
  };
}
